import type { FC } from "react";
import React, { memo, useId, useState } from "react";
import baseStyles from "../../Compare.module.scss";
import Button from "../../../../../../../shared-components/css-modules/lexus/atoms/Button";
import Icon from "../../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import { MAX_DEFAULT_SHARED_FEATURES, MAX_DEFAULT_UNIQUE_FEATURES } from "../../compareUtils";
import { useSharedAndUniqueFeatures } from "../../compareHooks";
import { CarConfigLabel } from "../../../../../../utils/labelUtils";

const FeaturesSingle: FC = () => {
    const sharedId = useId();
    const uniqueId = useId();
    const [sharedExpanded, setSharedExpanded] = useState(false);
    const [uniqueExpanded, setUniqueExpanded] = useState(false);

    const results = useSharedAndUniqueFeatures();
    const sharedIsExpandable = results.shared.length > MAX_DEFAULT_SHARED_FEATURES;

    const uniqueIsExpandable =
        typeof results.unique.find((unique) => (unique.length ?? 0) > MAX_DEFAULT_UNIQUE_FEATURES) !== "undefined";

    return (
        <>
            <div className={baseStyles.card}>
                <div className={baseStyles["card-body"]} id={sharedId}>
                    <h4 className={baseStyles["compare-section-title"]}>
                        <CarConfigLabel label="carConfigLbxCompareShared" />({results.shared.length})
                    </h4>
                    <ul className={baseStyles["compare-list"]}>
                        {results.shared
                            .slice(0, !sharedExpanded ? MAX_DEFAULT_SHARED_FEATURES : undefined)
                            .map((item) => (
                                <li key={item.id}>{item.name}</li>
                            ))}
                    </ul>
                </div>
                {sharedIsExpandable && (
                    <div className={baseStyles["card-footer"]}>
                        <Button
                            variant="clean"
                            sizing="full-width"
                            aria-expanded={sharedExpanded}
                            aria-controls={sharedId}
                            className={baseStyles["compare-view-all"]}
                            onClick={() => setSharedExpanded(!sharedExpanded)}
                        >
                            <CarConfigLabel label={sharedExpanded ? "carConfigLbxViewLess" : "carConfigLbxViewAll"} />
                            <Icon variant={sharedExpanded ? "minus" : "plus"} sizing="sm" aria-hidden="true" />
                        </Button>
                    </div>
                )}
            </div>
            <div className={baseStyles["compare-card"]}>
                <div className={baseStyles["card-body"]} id={uniqueId}>
                    {results.unique.map((unique, index) => (
                        // Index is unique here
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={index}>
                            <h4 className={baseStyles["compare-section-title"]}>
                                <CarConfigLabel label="carConfigLbxCompareUnique" />({unique.length})
                            </h4>
                            <ul className={baseStyles["compare-list"]}>
                                {unique
                                    .slice(0, !uniqueExpanded ? MAX_DEFAULT_UNIQUE_FEATURES : undefined)
                                    .map((item) => (
                                        <li key={item.id}>{item.name}</li>
                                    ))}
                            </ul>
                        </div>
                    ))}
                </div>
                {uniqueIsExpandable && (
                    <div className={baseStyles["card-footer"]}>
                        <Button
                            variant="clean"
                            sizing="full-width"
                            aria-expanded={sharedExpanded}
                            aria-controls={uniqueId}
                            className={baseStyles["compare-view-all"]}
                            onClick={() => setUniqueExpanded(!uniqueExpanded)}
                        >
                            <CarConfigLabel label={uniqueExpanded ? "carConfigLbxViewLess" : "carConfigLbxViewAll"} />
                            <Icon variant={uniqueExpanded ? "minus" : "plus"} sizing="sm" aria-hidden="true" />
                        </Button>
                    </div>
                )}
            </div>
        </>
    );
};

export default memo(FeaturesSingle);
